<template>
    <div class="page-block__item">
        <div class="page-block__item-content">
            <div class="layout">
                <div class="layout__item u-1/3-desk">
                    <span class="page-block__item-content-title">
                        {{ label }}
                    </span>
                </div>
                <!--
             -->
                <div class="layout__item u-2/3-desk">
                    <span class="label" :class="statusClass">
                        <img :src="statusIcon" class="label__icon" />

                        {{ trans('subscriptions.administrative_statuses.' + status) }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            required: true
        },
        status: {
            type: String,
            required: true
        }
    },
    computed: {
        /**
         * Status class.
         *
         * @return {string}
         */
        statusClass() {
            return 'label--' + this.status;
        },
        /**
         * Icon source.
         *
         * @return {string}
         */
        statusIcon() {
            return require('../assets/label-icons/' + this.status + '.svg');
        }
    }
};
</script>
